import React from 'react'
import PropTypes from 'prop-types'
import uniq from 'lodash.uniq'

import ProductDronePhoto from 'assets/icons/product-drone-photo.svg'
import ProductEveningPhoto from 'assets/icons/product-evening-photo.svg'
import ProductLocalAreaPhoto from 'assets/icons/product-local-area-photo.svg'
import ProductMastPhoto from 'assets/icons/product-mast-photo.svg'
import ProductPremiumPhoto from 'assets/icons/product-premium-photo.svg'
import ProductStandardPhoto from 'assets/icons/product-standard-photo.svg'
import ProductInterior from 'assets/icons/product-interior.svg'
import ProductVideo from 'assets/icons/product-video.svg'
import ProductMeasurement from 'assets/icons/product-measurement.svg'
import ProductVirtualTour from 'assets/icons/walkthrough.svg'

const productIcon = (__typename) => {
  switch (__typename) {
    case 'DronePhotoProduct':
      return ProductDronePhoto
    case 'DronePremiumPhoto':
      return ProductDronePhoto
    case 'EveningPhotoProduct':
      return ProductEveningPhoto
    case 'ElevatedPhotoProduct':
      return ProductMastPhoto
    case 'LocalAreaPhotoProduct':
      return ProductLocalAreaPhoto
    case 'MastPremiumPhotoProduct':
      return ProductMastPhoto
    case 'PremiumPhotoProduct':
      return ProductPremiumPhoto
    case 'StandardPhotoProduct':
      return ProductStandardPhoto
    case 'InteriorConsultingProduct':
      return ProductInterior
    case 'VideoProduct':
      return ProductVideo
    case 'MeasurementProduct':
      return ProductMeasurement
    case 'DigitalPlanDrawingProduct':
      return ProductMeasurement
    case 'VirtualTourProduct':
      return ProductVirtualTour
    case 'PremiumHighPhotoProduct':
      return ProductStandardPhoto
    case 'ExclusivePhotoProduct':
      return ProductStandardPhoto
    // no default
  }
}

const BookingListItemProducts = ({booking, iconSize = 25}) => {
  const products = uniq(booking.products.edges.map(({node}) => node.__typename))

  return (
    <div className="products">
      {products.map((product, i) => {
        const icon = productIcon(product)
        if (icon) {
          return <img key={i} src={icon} alt="" width={iconSize} />
        }
        return null
      })}
    </div>
  )
}

BookingListItemProducts.propTypes = {
  booking: PropTypes.object.isRequired,
  iconSize: PropTypes.number,
}

export default BookingListItemProducts
